import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=5455366d&lang=pug&"
import script from "./Filter.vue?vue&type=script&lang=js&"
export * from "./Filter.vue?vue&type=script&lang=js&"
import style0 from "./Filter.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5455366d')) {
      api.createRecord('5455366d', component.options)
    } else {
      api.reload('5455366d', component.options)
    }
    module.hot.accept("./Filter.vue?vue&type=template&id=5455366d&lang=pug&", function () {
      api.rerender('5455366d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/Filter.vue"
export default component.exports